import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, Zap, Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PremiumPrompt = ({ searchCount, onClose }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (searchCount === 3) {
      setOpen(true);
    }
  }, [searchCount]);

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  const handleSignUp = () => {
    setOpen(false);
    navigate('/auth');
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-lg" data-testid="premium-prompt">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <Crown className="text-primary" size={24} />
            <DialogTitle className="font-heading text-2xl">Unlock Premium Models</DialogTitle>
          </div>
        </DialogHeader>
        
        <div className="space-y-6 mt-4">
          <p className="text-muted-foreground">
            You're doing great! Sign up now to unlock unlimited searches and access to premium AI models.
          </p>

          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 rounded-lg bg-primary/5 border border-primary/20">
              <Sparkles className="text-primary mt-1 flex-shrink-0" size={20} />
              <div>
                <p className="font-medium text-foreground">GPT-5.2</p>
                <p className="text-sm text-muted-foreground">Most advanced language model</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 rounded-lg bg-secondary/5 border border-secondary/20">
              <Zap className="text-secondary mt-1 flex-shrink-0" size={20} />
              <div>
                <p className="font-medium text-foreground">Claude Opus 4.6</p>
                <p className="text-sm text-muted-foreground">Superior reasoning and analysis</p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 rounded-lg bg-accent/5 border border-accent/20">
              <Crown className="text-accent mt-1 flex-shrink-0" size={20} />
              <div>
                <p className="font-medium text-foreground">Faster Image Generation</p>
                <p className="text-sm text-muted-foreground">Priority queue for image creation</p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={handleSignUp}
              className="flex-1 rounded-full bg-gradient-to-r from-primary to-secondary hover:opacity-90 text-primary-foreground"
              data-testid="premium-signup-button"
            >
              Sign Up Free
            </Button>
            <Button
              onClick={handleClose}
              variant="outline"
              className="rounded-full"
            >
              Maybe Later
            </Button>
          </div>

          <p className="text-xs text-center text-muted-foreground">
            Free forever • No credit card required
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PremiumPrompt;